<template>
  <el-card shadow="hover" @click.native="toMap()">
    <!-- <span>{{XH}}</span> -->
    <div class="desc">
      <h1>
        <a>{{ Name }}</a>
      </h1>
      <p>电话：{{ Tel }}</p>
      <p>地址：{{ Address }}</p>
    </div>
  </el-card>
</template>
  
<script>
export default {
  name: "list_card",

  props: {
    //名称
    Name: {
      type: String,
      required: false,
      default: "",
    },
    //地址
    Address: {
      type: String,
      required: false,
      default: "",
    },
    //电话
    Tel: {
      type: String,
      required: false,
      default: "",
    },
    OBJECTID: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {};
  },

  inject: ["setMessage"],
  methods: {
    toMap() {
      var queryData = {
        url: "https://app-pad.nnrig.com/proxy/map/08db3fa5-dbcb-45c4-8ec9-04dde9b7de28/MapServer",
        // 查询配置
        query: {
          layerId: 0,
          where: "OBJECTID = " + this.OBJECTID,
        },
        // 属性弹框配置
        popupTemplate: {
          title: "{Name}",
          content: [
            {
              type: "fields",
              fieldInfos: [
                {
                  fieldName: "Name",
                  label: "名称",
                },

                {
                  fieldName: "Address",
                  label: "地址",
                },
              ],
            },
          ],
        },
        // 图层配置
        layerConfig: {},
      };
      this.setMessage("locateToGraphicByConfig", queryData);
    },
  },
};
</script>
  

<style scoped>
@import "../styles/left_list_card.css";
</style>
  


// WEBPACK FOOTER //
// src/components/zwfwmap-phone/left_bdcsld_list/list_card.vue